import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 35rem;
  background: #fff;
  border-radius: 0.17648rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  color: #212326;
  padding-top: 1.875rem;
  margin-bottom: 1rem;
`;

export const PhotoColectorContainer = styled.div`
  width: 90%;
  aspect-ratio: 16/9;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Footer = styled.div`
  margin-bottom: 2rem;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
